import { render, staticRenderFns } from "./MusicManagement.vue?vue&type=template&id=4eda11af&scoped=true&"
import script from "./MusicManagement.vue?vue&type=script&lang=js&"
export * from "./MusicManagement.vue?vue&type=script&lang=js&"
import style0 from "./MusicManagement.vue?vue&type=style&index=0&id=4eda11af&scoped=true&lang=css&"
import style1 from "@/assets/css/musicManagement.css?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/content.css?vue&type=style&index=2&lang=css&"
import style3 from "@/assets/css/font.css?vue&type=style&index=3&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda11af",
  null
  
)

export default component.exports